import { useAuthStore } from '@/lib/stores/authStore';
import type { Capability } from '@/lib/types/authorization';

/**
 * Whether the signed-in user's role may do something (see CAPABILITIES). This only
 * decides what the UI offers; the backend enforces it.
 *
 * A session saved before capabilities existed has none recorded yet, so it is
 * treated as allowed until `/auth/me` refreshes it — the backend still refuses
 * anyone who isn't allowed.
 */
export function useCan(capability?: Capability): boolean {
  return useAuthStore((state) => {
    if (!capability) return true;
    const capabilities = state.user?.capabilities;
    return capabilities === undefined ? true : capabilities.includes(capability);
  });
}
